import SubtleBadge from "components/common/SubtleBadge";
import React from "react";
import { Card, Image } from "react-bootstrap";

export default function SecurityPhotoSection({
  photoUrl,
  verified,
  handlePreviewClick,
}) {
  if (!photoUrl) {
    return (
      <Card className="custom-shadow border-0 mb-3">
        <Card.Body>
          <h5 className="fw-semibold mb-2 text-sm">Security Photo</h5>
          <p className="text-muted mb-0 text-xs">
            No security photo available.
          </p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <div className="shadow-smdd border-0 mb-4">
      <Card.Header className="bg-white d-flex align-items-center justify-content-between">
        <h5 className="fw-semibold mb-0 text-sm">Security Photo</h5>
      </Card.Header>

      <Card.Body className="d-flex align-items-centerdd gap-4">
        <div
          className="border rounded p-2 bg-light mt-2"
          style={{
            width: 180,
            height: 150,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => handlePreviewClick(photoUrl)}
        >
          <Image
            src={photoUrl}
            alt="Security selfie"
            fluid
            style={{ maxHeight: "100%", objectFit: "contain" }}
            draggable={false}
          />
        </div>

        <div>
          <p className="mb-1 fw-semibold">Live Capture / Selfie</p>
          <small className="text-muted">
            This photo is used to compare the user’s identity against the
            profile photo and submitted ID documents.
          </small>
          <small className="d-block mt-2 mb-3">
            (click image to view in full mode)
          </small>
          <div>
            <small>Status: </small>
            <SubtleBadge bg={verified ? "success" : "warning"}>
              {verified ? "Verified" : "Pending"}
            </SubtleBadge>
          </div>
        </div>
      </Card.Body>
    </div>
  );
}
